import { useState } from 'react';
import { NavbarComponent } from '../Navbar';
import { Sidebar, SidebarItem } from './Sidebar';
import { getDefaultSidebarItems } from './sidebarConstants';
import Footer from '../Footer';
import { projectConfig } from '../../config/project';
import { cn } from '../../utils/cn';

export interface MainLayoutProps {
  children: React.ReactNode;
  sidebarItems?: SidebarItem[];
  activeItem?: string;
  onSidebarItemClick?: (item: SidebarItem) => void;
  className?: string;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  sidebarItems,
  activeItem,
  onSidebarItemClick,
  className,
}) => {
  const defaultSidebarItems = sidebarItems || getDefaultSidebarItems();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const handleMobileSidebarToggle = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const handleSidebarItemClick = (item: SidebarItem) => {
    onSidebarItemClick?.(item);
    setIsMobileSidebarOpen(false);
  };

  return (
    <div
      className={cn(
        'flex flex-col min-h-screen',
        className || ''
      )}
      style={{ backgroundColor: 'var(--color-background-default)' }}
    >
      <NavbarComponent
        projectName={projectConfig.name}
        onMobileMenuToggle={handleMobileSidebarToggle}
      />

      <div className="flex flex-1 relative">
        {isMobileSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
            onClick={() => setIsMobileSidebarOpen(false)}
            onKeyDown={e => {
              if (e.key === 'Escape') {
                setIsMobileSidebarOpen(false);
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Close sidebar"
          />
        )}

        <Sidebar
          items={defaultSidebarItems}
          activeItem={activeItem}
          onItemClick={handleSidebarItemClick}
          isCollapsed={isSidebarCollapsed}
          isMobileOpen={isMobileSidebarOpen}
          onToggle={handleToggleSidebar}
          onMobileToggle={handleMobileSidebarToggle}
        />

        <main
          className="flex-1 min-w-0 overflow-x-hidden relative"
          style={{ backgroundColor: 'var(--color-background-default)' }}
        >
          <div className="h-full w-full p-4 sm:p-6 lg:p-8">
            {children}
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};

